<script>
import Vue from 'vue'
import _ from 'lodash'

function updateChangeClass(el, binding) {
  if (
    !binding.oldValue ||
    !binding.value ||
    (binding.value && binding.value.hasChange != binding.oldValue.hasChange)
  ) {
    const inputs = el.querySelectorAll('input, ui.search.selection')
    if (binding.modifiers.disable) _.each(inputs, i => (i.disabled = !_.isEmpty(binding.value)))
    if (binding.value && binding.value.hasChange) {
      el.classList.add('changed')
    } else {
      el.classList.remove('changed')
    }
  }
}

export default Vue.directive('diff-field', {
  // TODO add hint about previous value

  componentUpdated: function(el, binding, vnode) {
    updateChangeClass(el, binding)
  },

  inserted(el, binding) {
    updateChangeClass(el, binding)
  }
})
</script>
